import React from "react"
import PropTypes from "prop-types"
import { withParams } from "../../lib/withParams"
import PatientImage from "../PatientImage"
import Loader from "../Loader"
import { connect } from "react-redux"
import $ from "jquery"
import { Link } from "react-router-dom"
import DialogFooter from "../DialogFooter"
import { toggle } from "../../redux/selection"
import store from "../../redux"
import { queryBuilder } from "../../redux/query"
import Observations from "../Fhir/Observation"
import ImmunizationList from "../Fhir/ImmunizationList"
import ConditionList from "../Fhir/ConditionList"
import Encounter from "../Fhir/Encounter"
import CarePlan from "../Fhir/CarePlan"
import Person from "../Fhir/Person"
import ResourceList from "../Fhir/ResourceList"
import {
    getErrorMessage,
    getPatientName,
    getPatientPhone,
    getPatientEmail,
    getPatientHomeAddress,
    getPatientAge,
    getPath,
    intVal,
    getBundleURL,
    parseQueryString,
    getPatientMRN,
    getAllPages,
    getPatientDiagnosisReport,
    getICD10DiagnosisReport,
    getSDOHReport,
    getPHQ,
    getICD10DiagnosisReportPOF,
    getQuickSightUrl
} from "../../lib"
import "./PatientDetail.less"
import { ArrowLeft, ArrowRight, Group, List } from "lucide-react"
import ECMAnalytics from "../ECMAnalytics"
import DiabetesGraph from "../DiabetesGraph"
import DischargeSummary from "../DischargeSummary"
import QuestionnaireResponse from "../Fhir/QuestionnaireResponse"
import { icd10Codes, SDOHCodes, icd10CodesPOF } from "./ICDCodes"
import Medication from "../Fhir/Medication"
import ChronicConditions from "../ChronicConditions"
import AISummary from "../Fhir/AISummary"
import { GROUP_CONFIG } from "./groupConfig"
import ServiceRequest from "../Fhir/ServiceRequest"
import Procedure from "../Fhir/Procedure"

/**
 * Renders the detail page.
 */
export class PatientDetail extends React.Component {
    static propTypes = {
        match: PropTypes.object,
        settings: PropTypes.object,
        selection: PropTypes.object,
        query: PropTypes.object
    };


    constructor(...args) {
        super(...args)
        this.query = queryBuilder.clone();
        this.state = {
            loading: false,
            error: null,
            conditions: [],
            patient: {},
            index: 0,
            hasNext: false,
            groups: {},
            selectedSubCat: "",
            bundle: $.isEmptyObject(this.props.query.bundle) ?
                null :
                { ...this.props.query.bundle },
            selectedDocument: null,
            sdoh: [],
            phq9: null
        };
    }

    componentDidMount() {
        console.log("componentDidMount PatientDetail props 1", this.props);
        console.log("componentDidMount PatientDetail state 1", this.state);
        this.fetch(this.props.params.index);
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (newProps.params.index !== this.props.params.index) {
            this.fetch(newProps.params.index);
        }
    }

    fetch(index) {
        index = intVal(index, -1);
        if (index < 0) {
            return this.setState({ error: new Error("Invalid patient index") });
        }

        this.setState({ loading: true, index }, () => {
            this.fetchPatient(this.props.settings.server, index)
                .then(
                    state => {
                        console.log("Fetched Patient state", state);
                        this.setState({
                            ...state,
                            error: null,
                            loading: false
                        })
                    }
                )
                .catch(error => {
                    this.setState({
                        loading: false,
                        error
                    })
                })
        })
    }

    /**
     * This page receives an "index" url parameter. It will repeat the same
     * query from the search page but with limit=1 and offset=index so that the
     * search returns only one page. The reason for this is that we also have
     * these "Prev Patient" and "Next Patient" buttons that allow the user to
     * walk through the result one patient at a time.
     * @param {Object} server
     * @param {Object} server.url
     * @param {Object} server.type
     * @param {Number} index
     */
    fetchPatient(server, index) {

        return Promise.resolve({ ...this.state })

            // Run the main query to fetch the first page
            .then(state => {
                this.query.cacheId = null;
                this.query.offset = null;
                state.bundle = this.props.query.bundle;
                return state;
            })

            // Try to find the patient by index
            .then(state => {
                index = intVal(index, -1);
                if (index < 0) {
                    return Promise.reject("Invalid patient index");
                }

                state.patient = getPath(state, `bundle.entry.${index}.resource`);
                state.nextURL = getBundleURL(state.bundle, "next");
                state.hasNext = !!state.nextURL || (state.patient ? index < state.bundle.entry.length - 1 : false);
                return Promise.resolve(state);
            })

            // if no patient - jump to it's index
            .then(state => {
                if (!state.patient) {
                    let params = parseQueryString(state.nextURL);
                    this.query.setOffset(params._getpages, index);
                    return this.query.fetch(server).then(
                        bundle => {
                            state.bundle = bundle;
                            state.patient = getPath(state, `bundle.entry.0.resource`);
                            state.hasNext = state.patient ?
                                this.query.limit && this.query.limit > 1 ?
                                    state.bundle.entry.length > 1 :
                                    getBundleURL(state.bundle, "next") :
                                false;
                            return state;
                        }
                    )
                }
                return state;
            })

            .then(state => new Promise(resolve => {
                this.setState(state, () => resolve(state))
            }))

            // Find $everything
            .then(state => {
                let encodeUrl = btoa(`Patient/${state?.patient?.id}/$everything?_count=100`);
                let patientDetailUrl = `${server.url}/everything/nextPage?data=${encodeUrl}`;
                return getAllPages({ url: patientDetailUrl, server: server })
                    .then(data => {
                        console.log("Fetched $everything", data);
                        let groups = {};
                        data.forEach(entry => {
                            let resourceType = getPath(entry, "resource.resourceType") || "Other";
                            let type = resourceType;

                            if (type == "Observation") {
                                let subCat = String(
                                    getPath(entry, "resource.category.0.text") ||
                                    getPath(entry, "resource.category.coding.0.code") ||
                                    getPath(entry, "resource.category.0.coding.0.code") ||
                                    "Other"
                                ).toLowerCase();

                                subCat = subCat.split(/\-+/).map(token => {
                                    return token.charAt(0).toUpperCase() + token.substr(1)
                                }).join(" ");
                                type += " - " + subCat;
                            }

                            if (!Array.isArray(groups[type])) {
                                groups[type] = []
                            }
                            groups[type].push(entry)
                        })
                        console.log("Groups", groups);
                        groups.ECMAnalytics = data;
                        groups.DiabetesGraph = data;
                        groups.ChronicConditions = data;
                        // groups.DischargeSummary = data;
                        state.groups = groups
                        return state
                    })
            })
            .then(state => {
                // let patientMRN = "98049301D";
                let patientMRN = getPatientMRN(this.state.patient);
                let sdohUrl = `${server.url}/sdoh-icd?memberid=${patientMRN}`;
                return getQuickSightUrl({ url: sdohUrl, server: server })
                    .then(data => {
                        let sdohCodes = [];
                        Object.values(data.data.sdoh || {}).forEach(code => {
                            if (code.includes('|')) {
                                code.split('|').forEach(part => {
                                    sdohCodes.push(part.trim());
                                });
                            } else if (code && code.trim() !== "") {
                                sdohCodes.push(code.trim());
                            }
                        })
                        console.log("SDOH Codes", sdohCodes);
                        state.sdoh = sdohCodes;
                        return state
                    })
            })
            .then(state => {
                // let patientMRN = "95686684C";
                let patientMRN = getPatientMRN(this.state.patient);
                let sdohUrl = `${server.url}/depression?memberid=${patientMRN}`;
                return getQuickSightUrl({ url: sdohUrl, server: server })
                    .then(data => {
                        console.log("PHQ9", data);
                        if (data && data?.score !== undefined) {
                            state.phq9 = data.score;
                        }
                        return state
                    })
            })

            // Feed the results to the app
            .then(
                state => Promise.resolve(state),
                error => Promise.reject(new Error(getErrorMessage(error)))
            )
    }

    // Rendering methods -------------------------------------------------------

    renderPatient() {
        if (this.state.error) {
            return this.state.error + ""
        }

        let idLower = (this.state.patient.id || "").toLowerCase();
        let key = idLower && Object.keys(this.props.selection).find(k => k.toLowerCase() == idLower);
        let selected = key && this.props.selection[key] !== false;
        return (
            <>
                <div className="panel panel-default patient-detail-header">
                    {this.state.loading ? <Loader /> : null}
                    <div className="panel-body">
                        <div className="d-flex justify-content-between align-items-center" style={{ marginBottom: "0.5rem" }}>
                            <div className="d-flex align-items-center">
                                <span className="patientName">{getPatientName(this.state.patient) || (this.state.loading ? "loading..." : "Unknown")}</span>
                                <span className="patientMRN">MRN: {getPatientMRN(this.state.patient) || (this.state.loading ? "loading..." : "Unknown")}</span>
                            </div>
                            <div className="action-buttons">
                                <Link
                                    to={`/patient/${this.state.index - 1}`}
                                    className="btn prevBtn"
                                    disabled={this.state.index < 1}
                                    title="Previous Patient"
                                >
                                    <ArrowLeft size={20} />
                                </Link>
                                <Link className="btn browseBtn text-center" to="/patient-list" title="Browse Patients">
                                    <List size={20} />
                                </Link>
                                <Link
                                    to={`/patient/${this.state.index + 1}`}
                                    className="btn nextBtn"
                                    disabled={!this.state.hasNext}
                                    title="Next Patient"
                                >
                                    <ArrowRight size={20} />
                                </Link>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-lg-3">
                                <span className="label-header">DOB:</span>
                                <span className="label-value">
                                    {this.state.patient.birthDate || (this.state.loading ? "loading..." : "")}&nbsp;
                                    ({getPatientAge(this.state.patient) || (this.state.loading ? "loading..." : "")})
                                </span>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-lg-3">
                                <span className="label-header">Gender:</span>
                                <span className="label-value" style={{ textTransform: "capitalize" }}>{this.state.patient.gender || (this.state.loading ? "loading..." : "")}</span>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-lg-3">
                                <span className="label-header">Email:</span>
                                <span className="label-value">{getPatientEmail(this.state.patient) || (this.state.loading ? "loading..." : "")}</span>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-lg-3">
                                <span className="label-header">Phone:</span>
                                <span className="label-value">{getPatientPhone(this.state.patient) || (this.state.loading ? "loading..." : "")}</span>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-lg-6">
                                <span className="label-header">Address:</span>
                                <span className="label-value">{getPatientHomeAddress(this.state.patient) || (this.state.loading ? "loading..." : "")}</span>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-lg-6">
                                <span className="label-header">PHQ-9 (Score):</span>
                                <span className="label-value">{getPHQ(this.state.groups, this.state.phq9) || (this.state.loading ? "loading..." : "")}</span>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-lg-4 d-flex">
                                <span className="label-header" style={{ marginTop: "5px" }}>Dx Alert:</span>
                                <span className="label-value">
                                    {this.state.loading ? (
                                        <div className="diagnosis-container">
                                            <span className="diagnosis-chip icd-chip">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                    ) : getICD10DiagnosisReport(this.state.groups, icd10Codes)}
                                </span>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-lg-4 d-flex">
                                <span className="label-header" style={{ marginTop: "5px" }}>POF:</span>
                                <span className="label-value">
                                    {this.state.loading ? (
                                        <div className="diagnosis-container">
                                            <span className="diagnosis-chip icd-chip">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                    ) : getICD10DiagnosisReportPOF(this.state.groups, icd10CodesPOF)}
                                </span>
                            </div>
                            <div className="col-xs-12 col-sm-12 col-lg-4 d-flex">
                                <span className="label-header" style={{ marginTop: "5px" }}>SDOH:</span>
                                <span className="label-value">
                                    {this.state.loading ? (
                                        <div className="diagnosis-container">
                                            <span className="diagnosis-chip icd-chip">
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </span>
                                        </div>
                                    ) : getSDOHReport(this.state.groups, SDOHCodes, this.state.sdoh)}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    handleDocumentClick = (data) => {
        this.setState({ selectedDocument: data });
        store.dispatch(toggle(data));
        return (
            <div className="patient-sidebar-overlay">
                <div className="patient-sidebar" onClick={e => e.stopPropagation()}>
                    {/* Header */}
                    <div className="sidebar-header">
                        <h4>Patient Details</h4>
                        <button className="close-btn">
                            <i className="fa fa-times" />
                        </button>
                    </div>

                    {/* Patient Details */}
                    <div className="sidebar-patient-details">
                        {/* {this.renderPatientDetails()} */}
                    </div>

                </div>
            </div>
        );
    }

    renderResources(type) {
        let items = this.state.groups[type] || [];
        if (!items.length) {
            return (
                <p className="text-center text-muted">
                    No items of type "{type}" found
                </p>
            )
        }

        if (type.indexOf("Observation") === 0) {
            return <Observations resources={items} />;
        }

        switch (type) {
            case "Immunization":
                return <ImmunizationList resources={items} />;
            case "Condition":
                return <ConditionList resources={items} />
            case "Encounter":
                return <Encounter resources={items} />;
            case "CarePlan":
                return <CarePlan resources={items} />;
            case "QuestionnaireResponse":
                return <QuestionnaireResponse resources={items} type={type} settings={this.props.settings} handleDocumentClick={this.handleDocumentClick} />;
            case "Practitioner":
            case "RelatedPerson":
                return <Person resources={items} title={type} />;
            case "Patient":
                return (
                    <AISummary
                        resources={items}
                        title={type}
                        mrn={getPatientMRN(this.state.patient)}
                        // mrn="98334633F"
                        settings={this.props.settings}
                    />
                );
            case "ECMAnalytics":
                return <ECMAnalytics data={items} settings={this.props.settings} bundle={this.state.bundle} />;
            case "ChronicConditions":
                return <ChronicConditions
                    mrn={getPatientMRN(this.state.patient)}
                    // mrn="95830589A"
                    settings={this.props.settings}
                    bundle={this.state.bundle}
                />;
            case "DiabetesGraph":
                return <DiabetesGraph resources={items} />;
            case "DischargeSummary":
                return <DischargeSummary resources={items} />;
            case "MedicationDispense":
            case "MedicationRequest": {
                const dispense = this.state.groups["MedicationDispense"] || null;
                const request = this.state.groups["MedicationRequest"] || null;

                return (
                    <Medication
                        medicationDispense={dispense}
                        medicationRequest={request}
                        settings={this.props.settings}
                        handleDocumentClick={this.handleDocumentClick}
                    />
                );
            }
            case "ServiceRequest":
                return <ServiceRequest resources={items} settings={this.props.settings} type={type} />;
            case "Procedure":
                return <Procedure resources={items} settings={this.props.settings} type={type} />;

            default:
                return <ResourceList resources={items} type={type} settings={this.props.settings} handleDocumentClick={this.handleDocumentClick} />;
        }
    }

    render() {
        // let groups = Object.keys(this.state.groups).sort();
        let groups = Object.keys(this.state.groups)
            .sort()
            .filter(g => (g !== "ECMAnalytics" && g !== "DiabetesGraph" && g !== "DischargeSummary" && g !== "ChronicConditions" && g !== "Composition"));
        if (this.state.groups.ECMAnalytics) groups.push("ECMAnalytics");
        if (this.state.groups.DiabetesGraph) groups.push("DiabetesGraph");
        if (this.state.groups.DischargeSummary) groups.push("DischargeSummary");
        if (this.state.groups.ChronicConditions) groups.push("ChronicConditions");
        // console.log("Group", groups);
        let selectedSubCat = this.state.selectedSubCat
        if (!selectedSubCat || !this.state.groups[selectedSubCat]) {
            selectedSubCat = Object.keys(this.state.groups)[0] || ""
        }

        // For avoiding prininting medication two times in tab
        const groupsCopy = [...groups];
        const hasDisp = groupsCopy.includes("MedicationDispense");
        const hasReq = groupsCopy.includes("MedicationRequest");

        if (hasDisp && hasReq) {
            groupsCopy.splice(groupsCopy.indexOf("MedicationRequest"), 1);
        }

        const getGroupLabel = (k) => {
            return GROUP_CONFIG[k]?.label || k;
        };

        const shouldShowCount = (k) => {
            return GROUP_CONFIG[k]?.showCount ?? true;
        };

        return (
            <div className="page patient-detail-page" style={{ background: "#fff", paddingTop: "15px" }}>
                <div className="container">

                    <div>
                        {/* Your main UI */}
                        {this.state.selectedDocument && (
                            <div className="patient-sidebar-overlay" onClick={() => this.setState({ selectedDocument: null })}>
                                <div className="patient-sidebar" onClick={e => e.stopPropagation()}>
                                    <div className="sidebar-header">
                                        <h4>View Document</h4>
                                        <button
                                            className="close-btn"
                                            onClick={() => this.setState({ selectedDocument: null })}
                                        >
                                            <i className="fa fa-times" />
                                        </button>
                                    </div>

                                    <div className="sidebar-patient-details" style={{ height: "100%" }}>
                                        <iframe
                                            title="PDF Viewer"
                                            src={`data:application/pdf;base64,${this.state.selectedDocument}`}
                                            width="100%"
                                            height="100%"
                                            style={{ border: "none" }}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>

                    {this.renderPatient()}

                    {
                        groups.length ?
                            <div className="row patient-details theme4">
                                <br />
                                <div className="col-xs-12 col-sm-12 subcategory-nav">
                                    <div className="tab-strip">
                                        {groupsCopy.map((k, i) => (
                                            <a
                                                href="#"
                                                key={i}
                                                className={`tab-item ${k === selectedSubCat ? "active" : ""}`}
                                                onClick={e => {
                                                    e.preventDefault();
                                                    this.setState({ selectedSubCat: k });
                                                }}
                                            >
                                                <span>{getGroupLabel(k)}</span>
                                                {shouldShowCount(k) && (
                                                    <span className="tab-badge">
                                                        {this.state.groups[k]?.length || 0}
                                                    </span>
                                                )}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-xs-12 col-sm-12">
                                    <div className="resource-panel">
                                        {this.renderResources(selectedSubCat)}
                                    </div>
                                </div>
                            </div> :
                            this.state.loading ?
                                null :
                                <div className="row">
                                    <div className="col-xs-12 text-muted text-center">
                                        No additional details for this patient
                                    </div>
                                </div>
                    }
                </div>
                {
                    window.opener || (window.parent && window.parent !== window) ?
                        <nav className="navbar navbar-default navbar-fixed-bottom">
                            <div className="container-fluid" style={{ width: "100%" }}>
                                <div className="row">
                                    <div className="col-xs-12" style={{ paddingTop: 8 }}>
                                        <DialogFooter />
                                    </div>
                                </div>
                            </div>
                        </nav> :
                        null
                }
            </div>
        )
    }
}

export default connect(state => state)(withParams(PatientDetail))
